import React, { useEffect, useState } from "react";
import moment from 'moment';

import { CircularProgress, Grid, Tooltip, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

import { CreateCard,Nav,SplitScreen } from "../components/Interface";
import { Info, Table } from '../components/Global';
import { interactiveTypes } from '../config/allInteractives'
import { MuiRouterLink, OutlinedFab } from "../components/CustomMui";
import api from "../utils/api";

/**
 * 
 * @todo
 * 
 * Move Table container styles to table? (may not be possible due to "no results" behavior?)
 * 
 */

const useStyles = makeStyles((theme) => ({
  gridItem: {
    maxWidth: 234
  },
  menuRoot: {
    overflowX: 'hidden'
  },
  menuContainer: {
    padding: '32px 30px',
  },
  menuTitle: {
    fontWeight: 500,
  },
  tableContainer: {
    padding: '32px 30px',
    overflow: 'auto',
    width: '100%',
    minHeight: '100%', 
    boxSizing: "border-box",
    display: 'flex',
    flexDirection: 'column',
    '& .MuiTextField-root': {
      marginTop: 0,
      marginRight: 0,
    },
    '& .MuiToolbar-root': {
      minHeight: 0,
      padding: '0 2px 0 7px',
    }
  },
  noResultsIcon: {
    marginBottom: 15,
  },
  noResultsContainer: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
  },
  titleLinkWrapper: {
    position: 'relative',
    display: 'flex',
    '&::before': {
      content: '""',
      display: 'block',
      backgroundColor: theme.palette.neutral.light3,
      width: 'calc(100% + 24px)',
      height: '40px',
      borderRadius: '4px',
      position: 'absolute',
      top: '50%',
      left: '50%',
      transform: 'translate(-50%, -50%)',
      opacity: 0,
      transition: '.3s opacity'
    },
    '&:hover::before': {
      opacity: 1
    }
  },
  titleLink: {
    position: 'relative',
    '&:hover': {
      color: '#2E86DE'
    }
  },
  spinner: {
    margin: '0 auto',
    alignSelf: 'center',
  }
}));

const parseDate = (dateStr) => {
  const date = moment.utc(dateStr).format('MM/DD/YY')
  return date;
}

const getInteractiveLabel = (type) => {
  const intvs = interactiveTypes.filter(intv => {
    if (intv.name === type) {
      return true;
    }
    return false;
  })
  return intvs[0].label;
}

export function Dashboard() {
  const classes = useStyles();
  
  const [data, setData] = useState([]);
  const [spinner, setSpinner] = useState(true)

  useEffect(() => {
    document.title = "PAVILION Interactive Builder";
  }, []);

  useEffect(() => {

    api.getInteractives()
      .then(response => {
        setData(response.data);
        setSpinner(false)
      })

  }, [])

  const columns = [
    { title: 'Type', field: 'type',
      render: rowData => <Typography noWrap={true}>{getInteractiveLabel(rowData.type)}</Typography>, 
      customFilterAndSearch: (searchTerm, rowData) => getInteractiveLabel(rowData.type).indexOf(searchTerm) !== -1,
      width: '140px',
    },
    { title: 'Title', field: 'title',
      render: rowData => <span className={classes.titleLinkWrapper}>
                          <Tooltip title={rowData.title} arrow interactive leaveDelay={20}>
                            <Typography noWrap={true} className={classes.titleLink}><MuiRouterLink to={`/${rowData.type}/${rowData.id}`}>{rowData.title}</MuiRouterLink></Typography>
                          </Tooltip>
                        </span>
    },
    { title: 'Creator', field: 'creator',
      render: rowData => <Typography noWrap={true}>{rowData.creator}</Typography>, 
      width: '180px',
    },
    {
      title: 'Last Edited',
      field: 'lastEdited',
      type: 'date',
      render: rowData => <Typography noWrap={true}>{parseDate(rowData.lastEdited)}</Typography>,
      customFilterAndSearch: (searchTerm, rowData) => parseDate(rowData.lastEdited).indexOf(searchTerm) !== -1,
      defaultSort: 'desc',
      width: '110px',
    },
    { title: 'Created', field: 'created', type: 'date',
      render: rowData => <Typography noWrap={true}>{parseDate(rowData.created)}</Typography>, 
      customFilterAndSearch: (searchTerm, rowData) => parseDate(rowData.lastEdited).indexOf(searchTerm) !== -1,
      width: '110px',
    },
    { 
      title: '', 
      field: 'link',  
      render: rowData => <OutlinedFab component={MuiRouterLink} to={`/${rowData.type}/${rowData.id}`} underline="none"><i className="fas fa-arrow-right"></i></OutlinedFab>,
      width: '50px',
      sorting: false
    }
  ];

  const CreateMenu = (
    <div className={classes.menuRoot}>
      <Grid container spacing={3} className={classes.menuContainer}>
        <Grid item xs={12}>
          <Typography component="h2" variant="h4" className={classes.menuTitle}>Create New Item</Typography>
        </Grid>
        {
          interactiveTypes.map((intv,index) => (
            <Grid key={index} item xs={12} xl={6} className={classes.gridItem}>
              <CreateCard name={intv.longName ? intv.longName : intv.name}>{intv.label}</CreateCard>
            </Grid>
          ))
        }
      </Grid>
    </div>
  )

  const TableContainer = () => {
    if (data && data.length > 0) {
      return (
        <div className={classes.tableContainer}>
          <Table data={data} columns={columns}/>
        </div>
      )
    }

    return (
      <div className={classes.tableContainer}>
        {console.log('render dashboard')}
        <div className={`${classes.noResultsContainer} ${classes.tableContainer}`}>
          <img className={classes.noResultsIcon} src={require('../images/icon-empty.png')} alt='' aria-hidden />
          <Info
            heading="No items yet!"
            details="Be the first to create a new item, by selecting one of the options listed on the left."
          />
        </div>
      </div>
    )
   
  } 

  return (
    <React.Fragment>

      <Nav />

      <SplitScreen
          leftSide={CreateMenu}
          rightSide={spinner ? <CircularProgress className={classes.spinner} size={70} /> : TableContainer()}
        />

    </React.Fragment>
  );
}
